export default __webpack_public_path__ + "static/media/homeScreenNew.f1a5ea2c.svg";